require("!!/var/www/html/scora.io/frontend/scorauser/node_modules/script-loader/addScript.js")(require("!!/var/www/html/scora.io/frontend/scorauser/node_modules/raw-loader/index.js!/var/www/html/scora.io/frontend/scorauser/node_modules/chart.js/dist/Chart.bundle.min.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/chart.js/dist/Chart.bundle.min.js
// module id = 594
// module chunks = 8